import { render, staticRenderFns } from "./KEraserButton.vue?vue&type=template&id=07a4c000&"
import script from "./KEraserButton.vue?vue&type=script&lang=js&"
export * from "./KEraserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports